import { Text } from "@/components/ui/Text";
import {
  CreativeEditorDialog,
  CreativeEditorSection,
} from "./CreativeEditorDialog";
import type { CreativeUploadFrameProps } from "@/types/creative-library";

/** Gallery uploads stay inside the character workspace instead of opening another modal. */
export function CreativeUploadFrame({
  embedded,
  children,
  footer,
  ...dialog
}: CreativeUploadFrameProps) {
  if (!embedded)
    return (
      <CreativeEditorDialog {...dialog} footer={footer}>
        {children}
      </CreativeEditorDialog>
    );
  if (!dialog.open) return null;
  return (
    <CreativeEditorSection className="border-primary/20">
      <div data-testid={dialog.testId} className="flex min-w-0 flex-col gap-4">
        <Text size="sm">{dialog.title}</Text>
        {children}
        <div className="flex flex-wrap justify-end gap-2">{footer}</div>
      </div>
    </CreativeEditorSection>
  );
}
